
















import { Component, Mixins } from "vue-property-decorator";
import { Alert } from "@/models";
import AlertEditor from "@/components/AlertEditor.vue";
import PageGuide, { GuidePaths } from "@/components/PageGuide.vue";

@Component({
  components: {
    AlertEditor,
    PageGuide,
  },
})
export default class AlertCreate extends Mixins() {
  alert: Alert = new Alert({});

  guidePath = GuidePaths.ALERT_FEED;

  cancel() {
    this.$router.go(-1);
  }

  save() {
    return;
  }

  protected onSaved() {
    this.$router.push({ name: "AlertList" });
  }
}
